import { EscalationsTable } from "../../../Escalations/EscalationsTable";

export function ContactEscalations() {
  return (
    <div>
      <EscalationsTable context={ `contact` } />
    </div>
  );
}
